import { ListToFitFieldLayout } from 'Components/Layout/FieldLayout';
import { WorksheetBatchUpdateWorksheetField, getWorksheetBatchUpdateDefinition } from 'Components/WorksheetBatchUpdate';
import { WorksheetBatchUpdateApplyButton } from 'Components/WorksheetBatchUpdate/Core/WorksheetBatchUpdateUpdateDataSection/WorksheetBatchUpdateApplyButton';
import { WorksheetBatchUpdateCheckButton } from 'Components/WorksheetBatchUpdate/Core/WorksheetBatchUpdateUpdateDataSection/WorksheetBatchUpdateCheckButton';
import { WorksheetBatchUpdateUpdateDataInjectedPropsProvider } from 'Components/WorksheetBatchUpdate/Core/WorksheetBatchUpdateUpdateDataSection/WorksheetBatchUpdateUpdateDataInjectedPropsProvider';
import { WorksheetBatchUpdateUpdateDataMessagesSection } from 'Components/WorksheetBatchUpdate/Core/WorksheetBatchUpdateUpdateDataSection/WorksheetBatchUpdateUpdateDataMessagesSection';
import { hasNonEmptyValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import { pickBy } from 'ramda';
import React from 'react';
import { useSelector } from 'react-redux';
import './WorksheetBatchUpdateUpdateDataSection.scss';

/**
 * Provides a section to enter the data to update on the batch of worksheets.
 */
const WorksheetBatchUpdateUpdateDataSection: React.FC = () => {
  const typeId = useSelector((state) => state.worksheetBatchUpdate.typeId);
  const { worksheetFields = {} } = typeId ? getWorksheetBatchUpdateDefinition(typeId) : {};

  const fields = useSelector((state) => state.worksheetBatchUpdate.fields, deepEquals);

  const entryFields = pickBy<
    { [name: string]: WorksheetBatchUpdateWorksheetField },
    { [name: string]: WorksheetBatchUpdateWorksheetField }
  >((_, k) => fields[k].update ?? false, worksheetFields);

  return (
    <div className="WorksheetBatchUpdateUpdateDataSection">
      <div className="WorksheetBatchUpdateUpdateDataSection-Fields">
        <WorksheetBatchUpdateUpdateDataInjectedPropsProvider>
          <ListToFitFieldLayout>
            {Object.entries(entryFields).map(([k, v], i) =>
              React.cloneElement(v.entryComponent!, {
                name: k,
                horizontal: true,
                key: i,
              })
            )}
          </ListToFitFieldLayout>
        </WorksheetBatchUpdateUpdateDataInjectedPropsProvider>
      </div>
      <div className="WorksheetBatchUpdateUpdateDataSection-Buttons">
        {hasNonEmptyValue(entryFields) && <WorksheetBatchUpdateApplyButton />}
        <WorksheetBatchUpdateCheckButton />
      </div>
      <WorksheetBatchUpdateUpdateDataMessagesSection />
    </div>
  );
};

export default WorksheetBatchUpdateUpdateDataSection;
export { WorksheetBatchUpdateUpdateDataSection };
